import styled from "styled-components";
import {colors, devices, sizes} from "../../utils/styled/_variables.styled";
import "../../base/styled/_typograhpy.style";

const labelActive = `
label{
  top: -12px;
  left: 8px;
  font-size: 10px;
  font-weight: 600;
  color: ${colors.black} !important;
  padding:0 5px 0 5px;
}
`;

const marketoLabelFocusHandlerCss = ()=>{
  let cssChunk = "";
  ["text", "email", "tel"].forEach((val)=>{
    cssChunk = `
      ${cssChunk}
      .mktoForm .mktoFormRow :has(input[type="${val}"]:focus) {
        ${labelActive}
      }
    `
  });

  cssChunk = `
    ${cssChunk}
    .mktoForm .mktoFormRow :has(textarea:focus) {
      ${labelActive}
    }

    .mktoForm .mktoFormRow :has(select:focus) {
      ${labelActive}
    }
  `
  return cssChunk;
}

const marketoLabelNotEmptyHandlerCss = ()=>{
  let cssChunk = "";
  ["text", "email", "tel"].forEach((val)=>{
    cssChunk = `
      ${cssChunk}
      .mktoForm .mktoFormRow :has(input[type="${val}"]) :not(:has(input[type="${val}"]:placeholder-shown)) {
        ${labelActive}
      }
    `
  });

  cssChunk = `
    ${cssChunk}
    .mktoForm .mktoFormRow :has(textarea) :not(:has(textarea:placeholder-shown)) {
      ${labelActive}
    }
    .mktoForm .mktoFormRow :has(select[aria-invalid="false"]) {
      ${labelActive}
    }
  `
  return cssChunk;
}

const StickyBar = styled.div`
  padding: 0 96px 1px;

  @media ${devices.mobileAndTablet} {
    padding: 0
  }

  .stickyform {
    margin-right: auto;
    margin-left: auto;
    max-width: ${sizes.desktop - 1}px;
    position: relative;
    display: flex;
    @media ${devices.tabletLarge} {
      flex-direction: column-reverse;
    }
  }

  .mktoErrorDetail {
    color: #DC3545;
  }

  .stickyform__container {
    min-height: 778px;
    height: max-content;
    display: flex;
    align-items: flex-start;
    gap: 32px;
    width: 100%;

    .sticky-aem-content {
      flex: 1;
      width: 100%;

      .download__element__inner {
        @media (max-width: 1410px) {
          padding: 0 25px;
        }
      }
    }
    
    &__download-element{
      @media ${devices.desktop} {
        margin-left: 72px;
      }
    }
    
    @media ${devices.mobileAndTablet} {
      min-height: 0;
      flex-direction: column;
    }

    > p {
      margin: 80px 0 100px 96px;
      @media ${devices.tabletLarge} {
        margin-top: 128px;
        margin-bottom: 64px;
        margin: 128px 48px 64px 48px;
      }

      @media ${devices.mobile} {
        margin: 112px 24px 64px 24px;
      }
    }

    .downloadelement__content {
      margin: 0 0 80px 96px;
      @media ${devices.tabletLarge} {
        margin: 0 48px 128px 48px;
      }
      @media ${devices.mobile} {
        margin: 0 24px 112px 24px;
      }
    }

    .aem-container {
      flex: 1;

        .aem-Grid {
          
          @media ${devices.tablets} {
            padding: 0 48px;
          }

          @media ${devices.mobile} {
            padding: 0 24px;
          }
          .aem-GridColumn {
            padding: 0;
            margin: 0;
        }
      }
    }
  }

  .stickyform__content {
    width: 531px;
    max-width: 531px;
    background-color: ${colors.white};
    border: 1px solid ${colors.gray2};
    position: absolute;
    top: 0;
    right: 96px;
    max-height: calc(100vh - 210px);
    z-index: 1;
    
    @media ${devices.desktop} {
      position: sticky;
      display: flex;
      flex-direction: column;
      width: 100%;
      margin-top: ${props => props.overlap ? `-200px` : "16px"};
      top: 160px;
    }

    @media ${devices.tabletLarge} {
      overflow-y: visible;
      max-width: unset;
      max-height: none;
      width: 100%;
      height: 96px;
      display: flex;
      justify-content: space-between;
      position: sticky;
      top: unset;
      bottom: 0;
      border: none;
      border-top: 1px solid ${colors.gray2};
      padding: 39px 46px 40px;
    }
    
    @media ${devices.mobileAndTablet} {
      position: sticky;
      top: auto;
      bottom: 0; 
    }

    @media ${devices.mobile} {
      flex-direction: column;
      height: 152px;
      padding: 20px 24px;
    }

    .stickyform__form {
      padding: 39px;
      flex-grow: 1;
      overflow: auto;

      form{
        margin-top:24px;
      }

      ::-webkit-scrollbar {
      width: 7px;
    }
    
    ::-webkit-scrollbar-track {
      background-color: ${colors.white};
    }
      
    ::-webkit-scrollbar-thumb {
      border-right: 4px white solid;
      background: ${colors.blue}; 
    }

    // Firefox workaround
    scrollbar-width: thin;
    scrollbar-color: ${colors.blue} ${colors.white};
      
      @media ${devices.tabletLarge} {
        display: none;
      }
      > div {
        margin-top: 16px;
      }

      .stickyform__checkbox {
        > div {
          margin-top: 32px;
          > label > p > a {
            display: contents;
          }
        }
      }

      > p {
        margin-right: 16px;
        margin-top: 12px;
        font-weight: 300;
      }
    }
  }
  .stickyform__title {
    max-width: 435px;
    display: block;

    &.hide-desktop {
      @media ${devices.desktop} {
        display: none;
      }
    }
    
    @media ${devices.tabletLarge} {
      max-width: unset;
      align-self: center;
    }
  }

  .stickyform__button {
    margin-top: 48px;
    @media ${devices.tabletLarge} {
      display: none;
      margin-top: unset;
      height: fit-content;
      align-self: center;
    }
    > button {
      width: 100%;
    }

    &_overlap {
      @media ${devices.desktop} {
        background-color: ${colors.white};
        ${props => props.showBorder ? `border-top: 1px solid ${colors.gray2}` : ""};
        padding: 16px 40px;
        width: 100%;
        max-width: 531px;
        z-index: 10;
      }

      @media ${devices.tabletLarge} {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
  }

  .stickyform__handle {
    padding: 16px 0;
  }

  .stickyform__button_overlap {
    button {
      width: 100%;
    }
  }
`;


const EmbeddedFormWrapper = styled.div`
.mktoForm {

	font-family: inherit !important;

	font-size: 14px !important;

	position: relative !important;

	display: block !important;

	color: #262626 !important;

	width: 100% !important;

}

.mktoForm .mktoOffset {

	display: none !important;

}


.mktoForm .mktoFormCol {

	float: none !important;

	position: inherit !important;

	min-height: auto !important;

	margin-bottom: none !important;

}


.mktoForm .mktoGutter {

	display: none !important;

}

.mktoAsterix {
  display: none;
}
.mktoForm .mktoLabel {

	color: ${colors.gray5} !important;

	padding: none !important;

}


.mktoForm .mktoField {
    ::-webkit-input-placeholder {
    color:white;
    }

    :-moz-placeholder { /* Firefox 18- */
    color:white;
    }

    ::-moz-placeholder {  /* Firefox 19+ */
    color:white;
    }

    :-ms-input-placeholder {  
    color:white;
    }   
}


.mktoForm .mktoError .mktoErrorArrow {

	display: none !important;

}


.mktoForm .mktoError .mktoErrorMsg {

  font-size: 10px !important;
  font-weight: 600;
  margin-top: 8px;
  color: ${colors.error};

	background-image: none !important;

	border: none !important;

	box-shadow: none !important;

	text-shadow: none !important;

}


.mktoForm .mktoFormRow {

	margin-bottom: 24px !important;

	width: 100%;

}

.mktoForm .mktoButtonRow {

	position: relative;

	top: -10px;

	width: 100%;

}

  .mktoForm .mktoButtonRow button.disabled {
    background: rgb(230, 226, 220) !important;
    color: rgb(157, 150, 141) !important;
    pointer-events: none;
  }


.mktoForm .mktoField {

	float: none !important;

	display: block;

	width: 100% !important;

}


.mktoForm .mktoCheckboxList {

	overflow: hidden;

	padding: 0 !important;

	float: none;

	height: 24px;

	width: 24px !important;

	top: 2px;

	position: relative;

	margin-right: 10px;

}


.mktoForm .mktoCheckboxList input[type=checkbox] {

	height: 24px !important;

	width: 24px !important;
  -moz-appearance:initial 

}


.mktoForm .mktoCheckboxList input[type=checkbox]:before {

	content: "";

	position: absolute;

	top: 0;

	left: 0;

	width: 24px;

	height: 24px;

	border: 1px solid #878786;

	pointer-events: none;

}


.mktoForm .mktoCheckboxList input[type=checkbox]:after {

	content: "c";

	position: absolute;

	left: 1px;

	top: 1px;

	width: 22px;

	height: 22px;

	background: white;

	color: white;

	-webkit-transition: opacity 0.5s ease 0s, visibility 0s ease 0s, z-index 0.5s linear, margin 0.3s ease, border-width 0.3s ease, top 0.3s ease, top 0.3s ease, left 0.3s ease, right 0.3s ease, transform 0.4s ease, -webkit-transform 0.4s ease;

	-o-transition: opacity 0.5s ease 0s, visibility 0s ease 0s, z-index 0.5s linear, margin 0.3s ease, border-width 0.3s ease, top 0.3s ease, top 0.3s ease, left 0.3s ease, right 0.3s ease, transform 0.4s ease, -webkit-transform 0.4s ease;

	transition: opacity 0.5s ease 0s, visibility 0s ease 0s, z-index 0.5s linear, margin 0.3s ease, border-width 0.3s ease, top 0.3s ease, top 0.3s ease, left 0.3s ease, right 0.3s ease, transform 0.4s ease, -webkit-transform 0.4s ease;

	-webkit-transform: scale(1);

	-moz-transform: scale(1);

	-ms-transform: scale(1);

	-o-transform: scale(1);

	transform: scale(1);

}


.mktoForm .mktoCheckboxList input[type=checkbox]:checked:after {
	content: "";
  font-family: Icons;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-transform: none;
  font-weight: 400;
  text-align: center;
  line-height: 22px;
  color: white;
  border: 3px solid ${colors.bluePressed};
  outline: 2px solid ${colors.bluePressed};
  background-color: ${colors.bluePressed};
  position: absolute;
  top: 1px;
  height: 22px;
  width: 22px;
}

.mktoForm .mktoCheckboxList input[type=checkbox]:checked:before {
  content: "";
  position: absolute;
  width: 7px;
  height: 11px;
  border-bottom: 2px solid rgb(255, 255, 255);
  border-right: 2px solid rgb(255, 255, 255);
  transform: rotate(45deg);
  top: 5px;
  left: 8px;
  z-index: 1;
  border-left: 0;
  border-top: 0;
}

.mktoForm .mktoCheckboxList {

	top: -24px;

	position: relative;

	height: 24px;

	width: 24px;

	margin: 0 !important;

}


.mktoForm select {

  font-family: koerber, Arial, sans-serif;
  font-style: normal;
  font-size: 16px;
  line-height: 150%;
	background-color: white;

	border: 1px solid #262626;

	border-radius: 0;

	height: 48px;

	padding: 5px 16px 5px !important;

	line-height: 32px;

	outline: 0;

	box-shadow: 0 0 0 1px rgba(0, 96, 255, 0);

	width: calc(100% + 2px);

  &:hover {
        border: 2px solid ${colors.blue};
    }
    
  &:focus {
      border: 2px solid ${colors.blue};
  }

}

.mktoForm .mktoLabel {
    position: absolute;
    pointer-events: none;
    width: fit-content !important;

    background-color:#fff;
    top: 12px;
    left: 12px;
    transition: all 0.2s ease-out 0s ;

    &:has(~ *[aria-required="true"]){
      &:after{
        content:'*';
        background-color:#fff;
      }
    }
        
}

@-moz-document url-prefix() {
  .mktoForm .mktoLabel {
    top: -12px;
  left: 8px;
  font-size: 10px;
  font-weight: 600;
  color: ${colors.black} !important;
  padding:0 5px 0 5px;
  }
}

${marketoLabelFocusHandlerCss()}
${marketoLabelNotEmptyHandlerCss()}


.mktoForm .mktoFormRow :has(input[type="checkbox"]) {
  .mktoFieldWrap{
    position: unset !important;
    display: flex;
    flex-direction: row-reverse;
  }
  .mktoCheckboxList {
    top: 2px !important;
    width: 26px !important;
    &:before {
        content: "";
        border: 1px solid ${props => props.disabled ? colors.gray1 : colors.black};
        background: ${props => props.disabled ? colors.gray1 : colors.white};
        width: 100%;
        height: 100%;
        max-height: 24px;
        max-width: 24px;
        box-sizing: border-box;
        pointer-events: none;
        z-index: 0;
        position: absolute;
        top: 0;
    }

    &:hover {
        &:before {
            border: 2px solid ${colors.blue};
        }
    }

    input{
      opacity: 0;
      z-index: 2;
      cursor: pointer;
    }
    /* Style the checked state */
    input[type="checkbox"]:checked{
      opacity: 1;
    }
  }
  label{
    position: inherit;
    font-family: koerber, Arial, sans-serif;
    font-style: normal;
    font-size: 16px;
    line-height: 150%;
    font-weight: unset;
    pointer-events: all;
    padding-left: 12px;
    padding-right: 0;
    color: ${colors.black} !important;
    a{
      font-size: 16px;
      display: inline;
      font-weight: 300;
      text-decoration: underline;
    }
  }
}

.mktoForm .mktoFormRow {
  .wrapper__consent{
    position: unset !important;
    display: flex;
    flex-direction: row-reverse;

    .mktoCheckboxList {
      top: 2px !important;
      width: 26px !important;
      &:before {
          content: "";
          border: 1px solid ${props => props.disabled ? colors.gray1 : colors.black};
          background: ${props => props.disabled ? colors.gray1 : colors.white};
          width: 100%;
          height: 100%;
          max-height: 24px;
          max-width: 24px;
          box-sizing: border-box;
          pointer-events: none;
          z-index: 0;
          position: absolute;
          top: 0;
      }
  
      &:hover {
          &:before {
              border: 2px solid ${colors.blue};
          }
      }
  
      input{
        opacity: 0;
        z-index: 2;
        cursor: pointer;
      }
      /* Style the checked state */
      input[type="checkbox"]:checked{
        opacity: 1;
      }
    }
    label{
      position: inherit;
      font-family: koerber, Arial, sans-serif;
      font-style: normal;
      font-size: 16px;
      line-height: 150%;
      font-weight: unset;
      pointer-events: all;
      padding-left: 12px;
      padding-right: 0;
      color: ${colors.black} !important;
      a{
        font-size: 16px;
        display: inline;
        font-weight: 300;
        text-decoration: underline;
      }
    }
  }
}

.mktoForm .mktoFormRow :has(.mktoErrorMsg) {
  input{
    border-color: ${colors.error};
  }
}


.mktoForm input {

    height: 48px;
    width: 100%;
    padding: 12px 44px 12px 12px;
    border: 1px solid ${colors.black};
    outline: none;
    font-family: koerber, Arial, sans-serif;
    font-style: normal;
    font-size: 16px;
    line-height: 150%;
    &:hover {
        border: 2px solid ${colors.blue};
    }
    
    &:focus {
        border: 2px solid ${colors.blue};
    }
}


.mktoForm textarea {

  height: 88px;
  width: 100%;
  padding: 12px 44px 12px 12px;
  border: 1px solid ${colors.black};
  outline: none;
  font-family: koerber, Arial, sans-serif;
  font-style: normal;
  font-size: 16px;
  line-height: 150%;
  &:hover {
      border: 2px solid ${colors.blue};
  }

  &:focus {
      border: 2px solid ${colors.blue};
  }
}

.mktoForm .mktoFieldWrap {

	float: none !important;

	position: relative;

}


.mktoForm .mktoSimple {

	position: relative;

	top: -10px;

	margin: 0 !important;

}


.mktoForm .mktoSimple .mktoButton {
    display: flex !important;
    -webkit-box-pack: center !important;
    justify-content: center !important;
    -webkit-box-align: center !important;
    align-items: center !important;
    max-height: 48px !important;
    padding: 16px 24px !important;
    background: rgb(0, 96, 255) !important;
    color: rgb(255, 255, 255) !important;
    border-radius: 100px !important;
    border: none !important;
    white-space: nowrap !important;
    transition: background-color 0.3s ease-out 0s !important;
    cursor: pointer !important;
    width: 100% !important;
    margin-top: 48px !important;
    &:hover{
      background-color: rgb(0, 77, 204) !important;
    }
}
`
export { StickyBar, EmbeddedFormWrapper };
